import type React from 'react'

export interface ArrowProps {
  direction: 'left' | 'right'
  size: number
  color?: string
}

const Arrow: React.FC<ArrowProps> = ({ direction, size, color }) => {
  const pathData =
    direction === 'left'
      ? 'M7.38285 14.3828C7.72369 14.7237 8.27631 14.7237 8.61715 14.3828C8.95778 14.0422 8.95803 13.49 8.6177 13.1491L4.35125 8.875H14.125C14.6082 8.875 15 8.48325 15 8C15 7.51675 14.6082 7.125 14.125 7.125L4.35125 7.125L8.6177 2.8509C8.95803 2.50997 8.95778 1.95778 8.61715 1.61715C8.27631 1.27631 7.72369 1.27631 7.38285 1.61715L1.63636 7.36364C1.28491 7.71509 1.28491 8.28491 1.63636 8.63636L7.38285 14.3828Z'
      : 'M8.61715 1.61715C8.27631 1.27631 7.72369 1.27631 7.38285 1.61715V1.61715C7.04222 1.95778 7.04197 2.50997 7.3823 2.8509L11.6488 7.125H1.875C1.39175 7.125 1 7.51675 1 8V8C1 8.48325 1.39175 8.875 1.875 8.875H11.6488L7.3823 13.1491C7.04197 13.49 7.04222 14.0422 7.38285 14.3828V14.3828C7.72369 14.7237 8.27631 14.7237 8.61715 14.3828L14.3636 8.63636C14.7151 8.28491 14.7151 7.71509 14.3636 7.36364L8.61715 1.61715Z'

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={pathData} fill={color || '#333333'} />
    </svg>
  )
}

export default Arrow
